export default "4836dfd64744e940.svg"